module.exports = __webpack_public_path__ + "static/media/Betina G.40e00331.png";